import React, { useState } from "react";

import { passwordStrength } from "check-password-strength";

import { updatePassword } from "services";

import { incompleteMessage, useCancelAsyncOnUnmount, useCheckPasswordStrength, useNavigate, useToggleNavs, useTranslation } from "utils";

import { Button, Col, Form, Input, InputPassword, MainPage, NavigationHeader, PasswordStrengthPopup, Row, Message as message } from "components";

export const UpdatePassword = () => {
  const { t } = useTranslation(["user", "meta"]);
  useToggleNavs(false, false);

  const [loading, setLoading] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();
  const { setPasswordMatch, setPasswordStrength, currentPasswordStrength } = useCheckPasswordStrength();

  const complete = (v) => {
    const passwordAnalysis = passwordStrength(v.password);
    if (v.password !== v.confirmPassword) {
      message({ content: t("profileUpdate.password.match"), icon: "error" });
    } else if (passwordAnalysis.contains.length < 3 || v.password.length < 6) {
      message({ content: t("profileUpdate.password.weak"), icon: "error" });
    } else {
      setLoading(true);
      updatePassword({
        ...v,
        ...{ signal },
      })
        .then(() => {
          navigate("/user");
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const handlePasswordChange = (e, inputNumber) => {
    if (inputNumber === 1) {
      setPasswordStrength(e);
    }

    if (inputNumber === 2) {
      setPasswordMatch(e);
    }
  };

  return (
    <MainPage loading={loading} pageName={"profile"} containerClass="tiny">
      <NavigationHeader title={t("profileUpdate.password.headerTitle")} />
      <Form name="profile" onFinish={(v) => complete(v)} onFinishFailed={() => incompleteMessage(t("errors.mandatoryFields"))}>
        <Row>
          <Col>
            <h2>{t("profileUpdate.password.title")}</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <p style={{ maxWidth: "768px" }}>{t("profileUpdate.password.description")}</p>
          </Col>
        </Row>
        <Row>
          <Col>
            <Input name="email" label={t("profileUpdate.password.inputs.email")} rules={[{ required: true }]} />
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={12}>
            <InputPassword
              name="password"
              label={t("profileUpdate.password.inputs.password")}
              PasswordStrengthPopup={<PasswordStrengthPopup currentPasswordStrength={currentPasswordStrength} />}
              rules={[{ required: true }]}
              onChange={(e) => handlePasswordChange(e, 1)}
            />
          </Col>
          <Col sm={12} md={12}>
            <InputPassword
              name="confirmPassword"
              label={t("profileUpdate.password.inputs.confirm")}
              PasswordStrengthPopup={<PasswordStrengthPopup currentPasswordStrength={currentPasswordStrength} />}
              rules={[{ required: true }]}
              onChange={(e) => handlePasswordChange(e, 2)}
            />
          </Col>
        </Row>
        <Row className="margin-top-300">
          <Col className="center">
            <Form.Item>
              <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                {t("profileUpdate.password.inputs.button")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </MainPage>
  );
};
